// Comisiones de las OTAs (7-oct-2026). «Lo que te llega» en la ficha de la reserva
// (components/Reservas/PayData.vue): total − comisión de la OTA − IVA de la comisión.
// Placeholders: {channel} nombre del canal, {rate} y {vat} porcentajes ya formateados,
// {base} y {amount} importes ya formateados, {unit} tipo de habitación.
export const otaNet = {
  title: "Quello che ti arriva",
  gross: "Totale della prenotazione",
  grossOnChannel: "Totale della prenotazione su {channel}",
  grossOfUnit: "Totale {unit}",
  commission: "Commissione e addebiti di {channel} ({rate}%)",
  commissionOfBase: "Commissione e addebiti di {channel} ({rate}% di {base})",
  commissionReal: "Commissione di {channel} (comunicata dal canale)",
  vat: "IVA sulla commissione ({vat}%)",
  net: "Ti arriva (circa)",
  howItWorks: "Come si calcola",
  infoEstimate: "Stima fatta con le percentuali di «Commissioni delle OTA» dell'alloggio. L'OTA può trasferire una cifra leggermente diversa (arrotondamenti, promozioni, costi di pagamento).",
  infoBase: "La tassa di soggiorno e la cauzione non pagano commissione.",
  infoReal: "La commissione di questa prenotazione l'ha comunicata {channel}. L'IVA sulla commissione è una stima fatta con la percentuale di «Commissioni delle OTA», quindi quello che ti arriva resta approssimativo.",
  infoRealNoVat: "La commissione di questa prenotazione l'ha comunicata {channel}. Il bonifico può comunque variare un po' (arrotondamenti, costi di pagamento).",
  airbnbNet: "Airbnb paga già l'importo netto: quello che vedi è quello che ti arriva.",
  apart: "Non include {amount} che incassi a parte: quello non passa da {channel}.",
  theChannel: "l'OTA",
};
